import { useSelector } from 'react-redux';
import currentDealSelectors from '../store/selectors/currentDealSelectors';
import { IFinanceQuote } from '../../common/model/IFinanceQuote';

// Used to determine when the price or finance element is ready to be rendered
const usePriceLoadingState: () => boolean = () => {
  const financeQuote: IFinanceQuote = useSelector(currentDealSelectors.getFinanceQuote);
  const isDealLoading = useSelector(currentDealSelectors.getLoadingStatus);

  return isDealLoading || !financeQuote;
};

export default usePriceLoadingState;
